export const ASSIGNMENTS_STATUS = {
  ACTIVE: 'ACTIVE',
  FUTURE: 'FUTURE',
  PENDING: 'PENDING',
  VIRTUAL: 'VIRTUAL',
};
export const ASSIGNMENTS_STATUS_OPTIONS = {
  [ASSIGNMENTS_STATUS.ACTIVE]: 'Active',
  [ASSIGNMENTS_STATUS.FUTURE]: 'Future',
  [ASSIGNMENTS_STATUS.PENDING]: 'Pending',
  [ASSIGNMENTS_STATUS.VIRTUAL]: 'Virtual',
};

export const ASSIGNMENTS_STATUS_FILTER_OPTIONS = {
  [ASSIGNMENTS_STATUS.ACTIVE]: 'Active',
  [ASSIGNMENTS_STATUS.FUTURE]: 'Future',
};

export const PENDING_ASSIGNMENT_TOOLTIP = 'Pending — The assignment is awaiting CTO approval.';
export const SPOF_TOOLTIP = 'Single Point of Failure';
